<div class="full-width has-nav">
  <div class="container m-auto">
    <div class="separator">
      <span></span>
    </div>
    <div class="w-8 m-auto" [class.w-12]="deviceService.isMobile()">
      <h1>Contacte-nous!</h1>
      <p>
        Si tu as une question, une idée de collaboration, besoin d’un conseil ou juste envie de nous
        envoyer un mot doux, tu peux nous contacter via notre mail (<a href="mailto:contact@ledm.be"
          >contact&#64;ledm.be</a
        >) ou via nos réseaux sociaux.
      </p>
      <div class="link m-auto">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="mailto:contact@ledm.be">
          <ng-container>Envoyer un message</ng-container>
          <div class="line"></div>
        </a>
      </div>
    </div>
    <div class="w-10 m-auto image-container">
      <img alt="contact" ngSrc="/contact/contact.jpg" width="1500" height="1000" />
    </div>
  </div>
</div>

<div class="full-width articles-container">
  @if(lastArticles) {
  <div class="container m-auto articles">
    <div class="row title-link full-width">
      <h2 class="w-10">Nos derniers articles</h2>
      @if(!deviceService.isMobile()) {
      <div class="w-2 link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="/articles">
          <ng-container>Tous nos articles</ng-container>
          <div class="line"></div>
        </a>
      </div>
      }
    </div>
    <div class="row full-width">
      @for (article of lastArticles | async; track article.id) {
      <app-article-card
        class="w-4"
        [class.w-6]="deviceService.isTablet()"
        [class.w-12]="deviceService.isMobile()"
        [article]="article"
        [showDescription]="false"
      >
      </app-article-card>
      }
    </div>
    <div class="container">
      @if(deviceService.isMobile()) {
      <div class="link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="/articles">
          <ng-container>Tous nos articles</ng-container>
          <div class="line"></div>
        </a>
      </div>
      }
    </div>
  </div>
  }
  <!-- <div class="full-width instagram">
    <div class="container m-auto">
      <app-instagram-feed [green]="true"></app-instagram-feed>
    </div>
  </div> -->
</div>
